import { memo } from 'react';
import { Button } from 'antd';
import logo from 'assets/images/logo.svg'
import Clock from 'assets/images/overtime.png'
import IntlMessages from 'components/Message/IntlMessages';
import { useHistory } from 'react-router-dom';
import { Routes } from 'const';
import PageContainer from 'components/PageContainer';

const Terminated = () => {

  const history = useHistory();

  const gotoLoginPage = () => {
    history.replace(Routes.SignIn)
  }

  return (
    <PageContainer className="timeout-page">
      <div className="container">
        <div className="d-flex justify-content-center">
          <div className="col-12 col-sm-10 col-xl-6">
            <div className="card-mnc">
              <div className="head-timeout">
                <div className="border-logo">
                  <img src={logo} alt="logo" />
                </div>
                <div className="body-timeout">
                  <img src={Clock} alt="overtime" />
                  <h5 className="my-4 px-3">
                    <IntlMessages id="global.session.terminated" />
                  </h5>
                  <div className="row justify-content-center">
                    <div className="col-10 col-sm-6 col-md-5">
                      <Button className="btn button-ktb-main w-100" onClick={gotoLoginPage}>
                        <IntlMessages id="login.tab.normal.label.login" />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  )
}

export default memo(Terminated)